import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";
import { Field } from "@/components/Field";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [forgot, setForgot] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      if (forgot) {
        await api.post("/auth/forgot-password", { email });
        toast.success("Se l'email è registrata riceverai un link per reimpostare la password");
        setForgot(false);
      } else {
        const u = await login(email, password);
        nav(u.role === "admin" ? "/" : "/area-paziente", { replace: true });
      }
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grid min-h-screen lg:grid-cols-2">
      <div className="relative hidden overflow-hidden lg:block">
        <img src="/img/login.jpg" alt="Alimentazione sana" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0f172a]/80 via-[#0f172a]/20 to-transparent" />
        <div className="absolute bottom-0 p-12 text-white">
          <div className="text-sm font-semibold uppercase tracking-[0.2em] text-[#d9bf9f]">Siamo ciò che mangiamo</div>
          <h1 className="mt-3 max-w-md text-4xl font-extrabold leading-tight tracking-tight">La salute si costruisce a tavola.</h1>
        </div>
      </div>
      <div className="flex items-center justify-center px-6 py-12">
        <form onSubmit={submit} className="fade-up w-full max-w-sm space-y-6" data-testid="login-form">
          <img src="/img/logo.png" alt="Dott.ssa Simona Marretta - Biologa Nutrizionista" className="mx-auto w-64" data-testid="login-logo" />
          <div>
            <h2 className="text-3xl font-extrabold tracking-tight">{forgot ? "Password dimenticata" : "Accedi"}</h2>
            <p className="mt-1 text-sm text-slate-500">{forgot ? "Inserisci la tua email per ricevere il link." : "Area riservata a dottoressa e pazienti."}</p>
          </div>
          <Field label="Email">
            <input type="email" required className="field" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input" />
          </Field>
          {!forgot && (
            <Field label="Password">
              <input type="password" required className="field" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input" />
            </Field>
          )}
          {error && <div className="rounded-xl bg-rose-50 px-4 py-3 text-sm text-rose-700" data-testid="login-error">{error}</div>}
          <button className="btn-primary w-full py-3" disabled={loading} data-testid="login-submit-button">
            {loading ? "Attendere…" : forgot ? "Invia link" : "Accedi"}
          </button>
          <button type="button" onClick={() => { setForgot(!forgot); setError(""); }} className="w-full text-center text-sm font-medium text-[#3d655b] hover:underline" data-testid="login-forgot-password-link">
            {forgot ? "Torna al login" : "Password dimenticata?"}
          </button>
        </form>
      </div>
    </div>
  );
}
